// Exports
// -------

export default function getAssignmentCourseName(assignment) {
  return (
    assignment.course?.course_name ||
    `${assignment.display_name} - ${assignment.skill?.subject_name}`
  );
}
